import { render, staticRenderFns } from "./IperiusONEIcon.vue?vue&type=template&id=65279d62"
import script from "./IperiusONEIcon.vue?vue&type=script&lang=js"
export * from "./IperiusONEIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports